import React from "react"
import { useState, useEffect } from "react"
import {
    Box,
    Typography,
    Button,
    Card,
    CardContent,
    Grid,
    FormControl,
    IconButton,
    Stack,
    Autocomplete,
    TextField,
    Popover,
    Checkbox,
    Pagination,
    Dialog,
    DialogContent,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Paper,
    TablePagination,
    MenuItem,
} from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import "react-datepicker/dist/react-datepicker.css"
import {
    ApiGetOrphanAllocations,
    ApiGetVenueList,
    ApiGetNearbyShopper,
    ApiGetClientEntityByClientGroupId,
    ApiGetShopperPopUpDetails,
    ApiChangeOrphanAllocationsDate,
    ApiGetAllocationlist,
    ApiChangeApproveAllocationsDate,
    ApiGetShopperList,
    ApiGetBulkApproveAllocation,
    ApiGetVisitTimes,
} from "../../../apiService/Core/Apicall.tsx"
import useDebounce from "../CreateAllocations/UseDebounce.tsx"
// import Dcrage from "./Dcrage.tsx"
import dayjs, { Dayjs } from "dayjs"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import type { RootState } from "../../../global/config/store.ts"
import { toast } from "react-toastify"
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts"
import { useShopperDetails } from "../../../global/ShopperDetailsUtils.ts"
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { CancelOutlined } from "@mui/icons-material"
import { setLoadingFalse, setLoadingTrue } from "../../../global/config/Action/loadingActions.ts"
import store from "../../../global/config/store.ts"
import { setDate } from "../../../global/config/Reducer/dateSlice.ts"
import Dcrage from "../OrphanAllocation/Dcrage.tsx"

export default function MoveApprovedAllocations() {
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
    const dispatch = useDispatch()
    const [currentDate, setCurrentDate] = useState(new Date(selectedDateRedux))
    const [allocations, setAllocations] = useState<any>([])
    const [venueName, setVenueName] = useState([])
    const [venueNameValue, setVenueNameValue] = useState<any>("")
    const [clientEntityList, setClientEntityList] = useState<any>([])
    const [clientEntityId, setClientEntityId] = useState<any>(null)
    const debouncedClientEntityId = useDebounce(clientEntityId, 500)
    const debouncedVenue = useDebounce(venueNameValue, 700)
    // const [loanData, setLoanData] = useState()
    // const [searchText, setSearchText] = useState("");
    // Updated pagination state
    const [currentPage, setCurrentPage] = useState(1)
    const [totalCount, setTotalCount] = useState(0)
    const Clientlist = useSelector((state: RootState) => state.client.clientList)
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
    const [ClientId, setClientId] = useState(null)
    const [selectedAllocations, setSelectedAllocations] = useState<string[]>([]);
    const [selectAll, setSelectAll] = useState(false);
    const [showdateselect, setshowdateselect] = useState(false);
    const [selectedNewDate, setSelectedNewDate] = useState<Dayjs | null>(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [datalength, setdatalength] = useState<any>(null);
    const [isStartLoading, setisStartLoading] = useState(false);
    const [selectedShopperId, setSelectedShopperId] = useState<string>('');
    const [selectedShopperName, setSelectedShopperName] = useState<string>('');
    const [shopperList, setShopperList] = useState<any[]>([])
    const [searchQuery, setSearchQuery] = useState('')
    const [showDropdown, setShowDropdown] = useState(false);
    const [loanData, setLoanData] = useState();
    const [anchorEl, setAnchorEl] = useState(null);
    const [isAudit, setIsAudit] = useState(false);
    const [visitTimes, setVisitTimes] = useState<any[]>([]);
    const [filterTime, setFilterTime] = useState<any[]>([]);
    const [visitTimeId, setVisitTimeId] = useState<any>("")

    useEffect(() => {
        if (Clientlist.length > 2) {
            // setSelectedClient(Clientlist[2])
            setClientId(Clientlist[2].clientGroupName)
        }
    }, [Clientlist])

    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
            // const jobMonth = newDate.getMonth() + 1
            // const jobYear = newDate.getFullYear()
            // ApiCallGetAllocations(jobMonth, jobYear) // Reset to page 1 when month changes
            dispatch(setDate(newDate))
            return newDate
        })
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleNextMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
            // const jobMonth = newDate.getMonth() + 1
            // const jobYear = newDate.getFullYear()
            // ApiCallGetAllocations(jobMonth, jobYear) // Reset to page 1 when month changes
            dispatch(setDate(newDate))
            return newDate
        })
    }

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01")
        setCurrentDate(newDate)

        // // Call API with the new date
        // const jobMonth = newDate.getMonth() + 1
        // const jobYear = newDate.getFullYear()
        // ApiCallGetAllocations(jobMonth, jobYear) // Reset to page 1 when date changes
        dispatch(setDate(event.target.value))
    }

    const formatDate = (date: Date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
    }

    // useEffect(() => {
    //     const fetchData = async () => {
    //         // const currentDate = new Date()
    //         const jobMonth = currentDate.getMonth() + 1
    //         const jobYear = currentDate.getFullYear()
    //         debouncedVenue && await ApiCallGetAllocations(jobMonth, jobYear) // Start with page 1
    //         //await ApiCallGetVenueList()
    //         debouncedVenue && await handleGetClientList()
    //     }
    //     fetchData()
    //     return () => { }
    // }, [debouncedVenue, page, rowsPerPage])

    useEffect(() => {
        selectedClientName && setSelectedClient(selectedClientName)
    }, [selectedClientName])

    useEffect(() => {
        if (selectedDateRedux) {
            setCurrentDate(new Date(selectedDateRedux))
        }
    }, [selectedDateRedux])

    // Updated useEffect to handle client changes
    // useEffect(() => {
    //     if (selectedClient) {
    //         const jobMonth = currentDate.getMonth() + 1
    //         const jobYear = currentDate.getFullYear()
    //         clientEntityId && ApiCallGetAllocations(jobMonth, jobYear)
    //         setCurrentPage(1)
    //     }
    // }, [clientEntityId])

    const ApiCallGetVenueList = async (debouncedClientEntityId?: any) => {
        let data = `?offset=0&limit=500`
        if (clientEntityId) {
            data += `&clientEntityId=${clientEntityId}&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        } else if (selectedClient?.clientGroupName) {
            data += `&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        }
        const res = await ApiGetVenueList(data)
        const response = res?.data.map((item: any) => ({
            label: item.venueName,
            value: item.venueId,
            state: item.state,
            entityTypeName: item.entityTypeName
        }))
        setVenueName(response)
    }

    useEffect(() => {
        if (debouncedClientEntityId || selectedClient?.clientGroupName) {
            ApiCallGetVenueList(debouncedClientEntityId)
        } else {
            setVenueName([]) // Clear venue list when business is cleared
            setVenueNameValue(null) // Also clear selected venue
        }
    }, [debouncedClientEntityId, selectedClient?.clientGroupName])



    // useEffect(() => {
    //     ClientId && handleGetClientList()
    // }, [ClientId])

    useEffect(() => {
        if (selectedClient?.clientGroupName) {
            handleGetClientList()
        }
    }, [selectedClient?.clientGroupName])


    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
        if (!selectedClient?.clientGroupName) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            setClientEntityList(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }
    useEffect(() => {
        if (selectedClient && currentDate) { ApiCallGetAllocations(currentDate.getMonth() + 1, currentDate.getFullYear()) }
    }, [currentDate, selectedClient, clientEntityId, debouncedVenue, rowsPerPage, page, selectedShopperId])

    const ApiCallGetAllocations = async (jobMonth: any = "", jobYear: any = "") => {
        setAllocations([])
        setisStartLoading(true)
        store.dispatch(setLoadingTrue());
        let data = `?offset=${page * rowsPerPage}${clientEntityId ? `&clientEntityId=${clientEntityId}` : ""}&limit=${rowsPerPage}&jobMonth=${jobMonth}&jobYear=${jobYear}&allocationStatus=approved${selectedShopperId ? `&userId=${selectedShopperId}` : ""}`

        if (venueNameValue) data += `&venueId=${venueNameValue}`
        if (selectedClient?.clientGroupName) data += `&allocationClientGroup=${selectedClient.clientGroupName}`

        try {
            const res: any = await ApiGetBulkApproveAllocation(data)
            if (res) {
                setAllocations(res?.data)
            }

            // Set total count from API response for pagination
            if (res?.totalDataCount !== undefined) {
                setdatalength(res.totalDataCount)
                setSelectAll(false)
                setSelectedAllocations([])
            }

        } catch (error) {
            console.error("Error during API call:", error)
            toast.error("Failed to load allocations")
        }
        finally {
            store.dispatch(setLoadingFalse());
            setisStartLoading(false)
        }
    }

    const handleSelectCard = (id: string) => {
        if (selectedAllocations.includes(id)) {
            setSelectedAllocations(selectedAllocations.filter((item) => item !== id));
        } else {
            setSelectedAllocations([...selectedAllocations, id]);
        }
    };

    const fetchShoppers = async (query = '') => {
        try {
            const data = `?offset=0&limit=1000&status=active${query ? `&search=${query}` : ''}`;
            const res = await ApiGetShopperList(data);
            const filtered = res.data.filter((item: any) =>
                item.firstName.trim() !== '' && item.lastName.trim() !== ''
            );
            setShopperList(filtered);
            setShowDropdown(query.length > 0 && filtered.length > 0);
        } catch (error) {
            console.error('Error fetching shoppers:', error);
            toast.error('Failed to load shoppers');
        }
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            fetchShoppers(searchQuery);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchQuery]);

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedAllocations([]); // clear all
        } else {
            setSelectedAllocations(allocations.map((a: any) => a?.allocationId)); // select all allocation IDs
        }
        setSelectAll(!selectAll);
    };
    const handleUpateDetails = async () => {
        // setshowdateselect(true)
        try {
            const data = {
                allocationIds: selectedAllocations,
                dateToMove: dayjs(selectedNewDate).date(),
                monthToMove: dayjs(selectedNewDate).month() + 1,
                yearToMove: dayjs(selectedNewDate).year(),
                ...(visitTimeId != null && { visitTime: Number(visitTimeId) })
            }
            const res = await ApiChangeApproveAllocationsDate(data)
            if (res) {
                toast.success("Allocatios moved successfully")
            }
            setshowdateselect(false)
            ApiCallGetAllocations(currentDate.getMonth() + 1, currentDate.getFullYear())
            setVisitTimeId(null);
        } catch (error: any) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                String(error);
            toast.error(message)
        }
    }
    console.log("VisistTime ",visitTimeId);
    

    // ------------------------------------------- Chnage Pagination -----------------------------------------------
    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleHover = async (event: any, index: any, item?: any) => {
        setAnchorEl(event.currentTarget);
        try {
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth() + 1; // Months are zero-based, so add 1
            const currentYear = currentDate.getFullYear();

            const data = `?userId=${item?.userId?.userId}&currentMonth=${currentMonth}&currentYear=${currentYear}`;

            // Call API to get shopper details
            const response = await ApiGetShopperPopUpDetails(data);

            if (!response.status) {
                toast.error("Failed to load shopper details");
                return;
            }

            // Set shopper details from API response
            if (response.data) {
                setLoanData(response.data);
            }
        } catch (error) {
            //toast.error("Error loading shopper details");
        }
    };

    const handleGetVisitTimeList = async () => {
        try {
            const response: any = await ApiGetVisitTimes();
            setVisitTimes(response.data);
            console.log("visit times list", response.data);
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };
    useEffect(() => {
        handleGetVisitTimeList()
    }, [])

    console.log("Visist Time", visitTimes);
    console.log("ISAudit", isAudit);
    console.log("Filtered Visit Times:", filterTime);
    console.log("Id of Visit:", visitTimeId);

    useEffect(() => {
        const dayType = dayjs(selectedNewDate).day() === 0 || dayjs(selectedNewDate).day() === 6 ? "Weekend" : "Weekday";
        const filtered = visitTimes.filter(
            (item: any) => item?.weekType?.toLowerCase() === dayType?.toLowerCase()
        );
        setFilterTime(filtered)
        console.log("DayType:", dayType);
    }, [selectedNewDate, visitTimes])

    return (
        <div>
            <Box sx={{ p: 4 }} style={{ background: "white" }}>
                <Stack spacing={3}>
                    <Box sx={{ width: "100%" }}>
                        <h1 className="common-manage-h1" style={{ textAlign: "center" }}>
                            Bulk Approved Allocations
                        </h1>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: 'center',
                                justifyContent: "space-between",
                                marginBottom: "20px",
                                marginTop: "23px",
                            }}
                        >
                            <Stack direction="row" spacing={2}>
                                <FormControl size="small" sx={{ width: 180 }}>
                                    <Autocomplete
                                        disablePortal
                                        id="mm-autocomplete"
                                        options={Clientlist}
                                        value={selectedClient}
                                        getOptionLabel={(option) => option?.clientGroupName}
                                        isOptionEqualToValue={(option, value) => option.clientGroupDBName === value.clientGroupDBName}
                                        onChange={(event, newValue: any) => {
                                            // setSelectedClient(newValue)
                                            dispatch(setSelectedClientGroup(newValue))
                                            setClientId(newValue?.clientGroupName || null)
                                            setClientEntityId(null)
                                            setVenueNameValue(null)
                                            setClientEntityList([])
                                        }}
                                        // defaultValue="mmcommon"
                                        renderInput={(params) => <TextField {...params} label="Select Client" />}
                                        size="small"
                                    />
                                </FormControl>
                                <FormControl size="small" sx={{ width: 180 }}>
                                    <Autocomplete
                                        disablePortal
                                        id="beacon-autocomplete"
                                        options={clientEntityList.filter((item: any) => item.clientEntityId !== null)}
                                        getOptionLabel={(option) => option?.entityName || ""}
                                        onChange={(event, newValue: any) => {
                                            setClientEntityId(newValue?.clientEntityId || null)
                                            setIsAudit(newValue?.entityName === "Audit");
                                            if (!newValue) {
                                                setVenueNameValue(null)
                                            }
                                        }}
                                        value={clientEntityList.find((option: any) => option?.clientEntityId === clientEntityId) || null}
                                        renderInput={(params) => <TextField {...params} label="Select Business" />}
                                        size="small"
                                    />
                                </FormControl>
                                <FormControl size="small" sx={{ width: 250 }}>
                                    <Autocomplete
                                        disablePortal
                                        id="mm-autocomplete"
                                        options={venueName}
                                        getOptionLabel={(option: any) => `${option?.label} (${option?.state}) (${option?.entityTypeName})`}
                                        value={venueName.find((option: any) => option.value === venueNameValue) || null}
                                        onChange={(event, newValue: any) => {
                                            setVenueNameValue(newValue?.value || null)
                                        }}
                                        defaultValue=""
                                        renderInput={(params) => <TextField {...params} label="Search Site" />}
                                        size="small"
                                    />
                                </FormControl>
                            </Stack>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    // marginBottom: "70px",
                                }}
                            >
                                <IconButton onClick={handlePrevMonth}>
                                    <ChevronLeftIcon />
                                </IconButton>
                                <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                                    <input
                                        type="month"
                                        value={formatDate(currentDate)}
                                        onChange={handleDateChange}
                                        className="primary-color"
                                        style={{
                                            border: "none",
                                            background: "none",
                                            fontSize: "1.25rem",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            fontFamily: "inherit",
                                        }}
                                    />
                                </Box>
                                <IconButton onClick={handleNextMonth}>
                                    <ChevronRightIcon />
                                </IconButton>
                            </Box>
                            <Box className="d-flex justify-content-between align-items-center" gap={1}>
                                <Stack direction="row" spacing={0}>
                                    <Box width={'250px'} sx={{ position: 'relative' }}>
                                        <TextField
                                            fullWidth
                                            label="Search Shopper"
                                            value={selectedShopperId ? selectedShopperName : searchQuery}
                                            onChange={(e) => {
                                                setSearchQuery(e.target.value);
                                                if (!e.target.value) {
                                                    setSelectedShopperId('');
                                                    setSelectedShopperName('');
                                                }
                                            }}
                                            onFocus={() => searchQuery && setShowDropdown(true)}
                                            InputProps={{
                                                endAdornment: selectedShopperId && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => {
                                                            setSelectedShopperId('');
                                                            setSelectedShopperName('');
                                                            setSearchQuery('');
                                                        }}
                                                    >
                                                        <CancelOutlined fontSize="small" />
                                                    </IconButton>
                                                )
                                            }}
                                        />
                                        {showDropdown && shopperList.length > 0 && (
                                            <Box sx={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                right: 0,
                                                zIndex: 9999,
                                                bgcolor: 'background.paper',
                                                maxHeight: 250,
                                                overflow: 'auto',
                                                border: '1px solid #ccc',
                                                boxShadow: 3,

                                            }}>
                                                {shopperList.map((shopper) => (
                                                    <MenuItem
                                                        key={shopper.userId}
                                                        onClick={() => {
                                                            setSelectedShopperId(shopper.userId);
                                                            setSelectedShopperName(`${shopper.firstName} ${shopper.lastName} (${shopper.userName}) (${shopper.emailId}) (${shopper.contactNo})`);
                                                            setSearchQuery('');
                                                            setShowDropdown(false);
                                                        }}
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            '&:hover': { bgcolor: '#f5f5f5' }
                                                        }}
                                                    >
                                                        <span>{shopper.firstName} {shopper.lastName} ({shopper.userName}) ({shopper.emailId}) ({shopper.contactNo})</span>
                                                    </MenuItem>
                                                ))}
                                            </Box>
                                        )}
                                    </Box>
                                </Stack>
                                <Box>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className="table-row-background"
                                        onClick={() => { setshowdateselect(true) }}
                                    >Update Details</Button>
                                </Box>
                            </Box>
                        </Box>
                    </Box>


                </Stack>
                <Box>
                    <TableContainer
                        component={Paper}
                        sx={{ mb: 4, border: "1px solid #ccc" }}
                    >
                        <Table>
                            <TableHead sx={{ bgcolor: "#7a7d52" }}>
                                <TableRow>
                                    <TableCell padding="checkbox" sx={{ color: "white" }}>
                                        <Checkbox
                                            checked={selectAll}
                                            onChange={handleSelectAll}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ color: 'white' }}>ID</TableCell>
                                    <TableCell sx={{ color: 'white' }}>Status</TableCell>
                                    <TableCell sx={{ color: 'white' }}>Store Name</TableCell>
                                    <TableCell sx={{ color: 'white' }}>User Name</TableCell>
                                    <TableCell sx={{ color: 'white' }}>Group Name</TableCell>
                                    <TableCell sx={{ color: 'white' }}>Type</TableCell>
                                    <TableCell sx={{ color: 'white' }}>Visit Date</TableCell>
                                    <TableCell sx={{ color: 'white' }}>Visit Time</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {allocations?.length > 0 ? allocations.map((item: any, index: any) => (
                                    <TableRow key={index}>
                                        <TableCell padding="checkbox" sx={{ color: "white" }}>
                                            <Checkbox
                                                checked={selectedAllocations?.includes(item?.allocationId)}
                                                onChange={() => handleSelectCard(item?.allocationId)}
                                            />
                                        </TableCell>
                                        <TableCell>{item?.allocationId}</TableCell>
                                        <TableCell>{item?.allocationStatusId?.statusDesc}</TableCell>
                                        <TableCell>{item?.venueId?.venueName}</TableCell>
                                        <TableCell sx={{ cursor: "pointer" }} onClick={(e) => {
                                            //setLoanData(item);
                                            handleHover(e, index, item);
                                        }}>{item?.userId?.firstName} {item?.userId?.lastName}</TableCell>
                                        <TableCell>{item?.allocationClientGroup}</TableCell>
                                        <TableCell>{item?.venueId?.clientEntityId?.entityTypeId?.entityTypeName}</TableCell>
                                        <TableCell>{dayjs(item?.appliedData?.selectedVisitDate).format('DD/MM/YYYY')}</TableCell>
                                        <TableCell>{item?.appliedData?.selectedVisitTime?.visitTimeInformation}</TableCell>
                                    </TableRow>
                                )) : <TableRow><TableCell colSpan={8}>No Data Found</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            component="div"
                            count={datalength}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>

                    <Popover
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                        }}
                    >
                        {loanData ? (<Dcrage handleClose={handleClose} loanData={loanData} />) : null}
                    </Popover>

                </Box>

            </Box>

            <Dialog open={showdateselect}>
                <DialogContent>
                    <Box className='d-flex align-items-center justify-content-end'>
                        <IconButton onClick={() => { setshowdateselect(false) }}><CancelOutlined /></IconButton>
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateCalendar
                            // minDate={dayjs(currentDate).startOf("month")}
                            // maxDate={dayjs(currentDate).endOf("month")} 
                            value={selectedNewDate}
                            //    views={["month", "year"]}   
                            onChange={(newValue) => setSelectedNewDate(newValue)}
                        />
                    </LocalizationProvider>
                    {isAudit && (
                        <Box className="d-flex align-items-center justify-content-center mb-2">
                            <FormControl size="small" sx={{ width: 250 }}>
                                <Autocomplete
                                    disablePortal
                                    id="visit-time-autocomplete"
                                    options={filterTime}
                                    getOptionLabel={(option: any) => option.visitTimeInformation || ""}
                                    value={filterTime.find((option: any) => option.visitTimeId === visitTimeId) || null}
                                    onChange={(event, newValue: any) => {
                                        setVisitTimeId(newValue?.visitTimeId || null)
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Select Visit Time" />}
                                    size="small"
                                />
                            </FormControl>
                        </Box>
                    )}
                    <Box className='d-flex align-items-center justify-content-center'>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            onClick={() => { handleUpateDetails() }}
                        >Update</Button>
                    </Box>
                </DialogContent>
            </Dialog>
            {isStartLoading && (
                <div
                    className="loader-overlay"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        // background: 'rgba(0, 0, 0, 0.8)',
                        zIndex: 9999,
                    }}
                >
                    <div
                        style={{
                            border: '4px solid rgba(103, 107, 65, 1)',
                            borderRadius: '50%',
                            borderTop: '4px solid white',
                            width: 35,
                            height: 35,
                            animation: 'spin 0.6s linear infinite',
                        }}
                    ></div>

                    {/* Add animation style manually */}
                    <style>
                        {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
                    </style>
                </div>
            )}
        </div >
    )
}
